<template>
    <div  >
      <select-shop
        :loadingButton="loadingButton"
        v-on:getData="setShop"
      ></select-shop>
      <CCard >
            <div class="dashboard-banner p-2" >
                <CRow >
                    <CCol lg="8" xl="12" sm="12" md="6" col="12">
                        <div class="dashboard-banner__text pb-0" v-if="$i18n.locale === 'th'">
                            <h3 class="font-weight-bold  mb-4 text-left ">
                                แผนการใช้งานปัจจุบันของคุณคือ  <span class="text-success">Standard (ทดลองใช้งาน)</span>
                            </h3>
                            <h5 class="text-left lead text-muted">ติดต่อฝ่ายบริการลูกค้าเพื่อเปิดใช้ใช้บริการ <span class="text-success">Silom Dashboard</span></h5>
                            <CButton class="m-0 p-0"  >
                                <a href="https://liff.line.me/1645278921-kWRPP32q/?accountId=silompos" class="info-btn" target="_blank">
                                    <img src="/img/question.png" class="line-btn-icon">
                                    <span style="vertical-align: middle; font-weight: lighter; color: white" >
                                    ติดต่อพนักงาน
                                    </span>
                                </a>
                            </CButton>
                        </div>
                        <div class="dashboard-banner__text pb-0" v-else>
                            <h3 class="font-weight-bold  mb-4 text-left ">
                              Your current plan is <span class="text-success">Standard (Offline)</span>
                            </h3>
                            <h5 class="text-left lead text-muted">Please contact our support to continue. <span class="text-success">Silom Dashboard</span></h5>
                            <CButton class="m-0 p-0"  >
                                <a href="https://liff.line.me/1645278921-kWRPP32q/?accountId=silompos" class="info-btn" target="_blank">
                                    <img src="/img/question.png" class="line-btn-icon">
                                    <span style="vertical-align: middle; font-weight: lighter; color: white" >
                                    Contact our
                                    </span>
                                </a>
                            </CButton>
                        </div>
                    </CCol>
                </CRow>
            </div>
      </CCard>
      <CCard>
        <CCardBody class="mb-0 pb-0">
            <CRow class="justify-content-center">
                <CCol lg="8" >
                  <img src="/img/promotegrab/banner_Prgrab30d1.png " class="float-center" style="    width: -webkit-fill-available;" />
       
                </CCol>
                <CCol lg="4">
                    <div v-if="$i18n.locale === 'th'">
                        <h3 class="font-weight-bold mt-3 text-success text-left">
                        เพียงเชื่อมต่อ <img  src="/img/grabFood.svg" width="110px;" > 
                        </h3>
                        <h5> เพื่อรับสิทธิ์ใช้งาน Silom POS ฟรี 1 เดือน</h5>
                        <small v-html="$t('grabIntergrationDesAdd')" class="text-description text-muted "></small>
                        <a href="https://support.silompos.com/th/category/grab-x-silom-wl8k28/" target="_blank"> <small class="text-info">{{ $t('seemore') }}</small></a>
                    </div>
                    <div v-else>
                        <h3 class="font-weight-bold mt-3 text-success text-left">
                        Just integrate with <img  src="/img/grabFood.svg" width="110px;" > 
                        </h3>
                        <h5> Sign Up Now and Get 1 Month Free of Silom POS</h5>
                        <small v-html="$t('grabIntergrationDesAdd')" class="text-description text-muted "></small>
                        <a href="https://support.silompos.com/th/category/grab-x-silom-wl8k28/" target="_blank"> <small class="text-info">{{ $t('seemore') }}</small></a>
                    </div>
                    <CButton  color="success" class="text-center mt-2 "  v-on:click="verifyModal = true"  v-if="$i18n.locale === 'th'"> เชื่อมต่อ <img  src="/img/grabFoodWhite.svg" width="70px;" ></CButton>
                    <CButton  color="success" class="text-center mt-2 "  v-on:click="verifyModal = true"  v-else> Integrate <img  src="/img/grabFoodWhite.svg" width="70px;" ></CButton>

                </CCol>
                
            </CRow>
            <br/>

        </CCardBody>
        
      </CCard>
        <modal size="xl" :show.sync="verifyModal"  :title="$t('grabIntegration')" :footer="false">
            <div class="text-center ">
                <img src="/img/promotegrab/warningIn.jpg" style="width: 75%;">
             </div>
            <div class="text-center mb-4">
              <CButton @click="$router.push({name: 'GrabIntergrationForStandard'})" color="success" 
                       size="lg"  > 
                      เชื่อมต่อ <img  src="/img/grabFoodWhite.svg" width="90px;" ></CButton>
            </div>

          </modal>
    </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        loadingButton: true,
        verifyModal :  false
      }
    },
    components: {

    },
    computed: {
      ...mapGetters(['shops', 'shopObjectId']),
      shopObjectId: {
        get() {
          return this.$store.getters.shopObjectId
        },
        set(newValue) {
          return this.$store.dispatch('setShop', newValue)
        },
      },
      slides() {
        return [
                {
                    image: '/img/promotegrab/banner_Prgrab1.png',
                    buttonLabel: '',
                    buttonLink: '',
                    icon: ''
                },
                {
                    image: '/img/promotegrab/banner_Prgrab2.png',
                    buttonLabel: '',
                    buttonLink: '',
                    icon: ''
                },
                {
                    image: '/img/promotegrab/banner_Prgrab30d2.png',
                    buttonLabel: '',
                    buttonLink: '',
                    icon: ''
                },
                {
                    image: '/img/promotegrab/banner_Prgrab4.png',
                    buttonLabel: '',
                    buttonLink: '',
                    icon: ''
                },
            ]
        }
    },
    methods: {
      setShop() {
        this.$store.dispatch('getPermission')
      },
    },
  }
  </script>
<style >
  .grablist-image {
    width: auto;
    height: 200px;
    object-fit: cover; /* ทำให้รูปภาพเต็มพื้นที่สี่เหลี่ยมจตุรัส */
    /* border: #cdcdcd 1px solid; */
    border-radius: 10px;
    /* box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3); */
}
.slide-content {
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center; 
    text-align: center;
    
}
.img-banner-grab {
  position: absolute; 
  bottom: 100px; left: 280px;
}

.bg-grab{
    display: flex;
    background-image: url("/img/exp.jpg");
    background-position: left top; /* จัดตำแหน่งภาพ */
}
.dashboard-banner {
  display: flex;
  background-image: 
    /* linear-gradient(to right, #ffffff 0%, rgba(255, 255, 255, 0.1)),  */
    url('/img/promotegrab/standard01.png');
  background-repeat: no-repeat;
  background-position: right bottom; /* จัดตำแหน่งภาพ */
  background-size: contain; 
  /* min-height:250px; */
  /* background-size: cover; */
}

.dashboard-banner__text {
  flex: 1;
  padding: 10px;
}
.info-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    background-color: #29b289; /* สีพื้นหลังปุ่ม */
    border-radius: 5px;
    text-decoration: none;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

@media (max-width: 768px) {
  .dashboard-banner {
    background-size: 60px auto;
    /* padding-left: 80px; */
    min-height: 80px;
  }

  .dashboard-banner__text h5 {
    font-size: 14px;
  }
}
.line-btn-icon {
    width: 20px;
    height: 20px;
    margin-right: 5px; /* เว้นระยะห่างระหว่างไอคอนและข้อความในปุ่ม */
}
@media (max-width: 500px) {
    .dashboard-banner {
        background-image: 
            linear-gradient( #ffffff 70%, rgba(255, 255, 255, 0.1)), 
            url('/img/promotegrab/standard01.png'); /* เปลี่ยน path ตามจริง */ /* ใช้รูปโปร่งจาง หรือ gradient */
        background-size: cover;
        background-position: center;
        min-height: 200px;
    }
}
@media (min-width: 1300px) {
  .dashboard-banner {
    display: flex;
    background-image: 
      /* linear-gradient(to right, #ffffff 0%, rgba(255, 255, 255, 0.1)),  */
      url('/img/promotegrab/standard01.png');
    background-repeat: no-repeat;
    background-position: right center; 
    background-size: contain;
    min-height: 250px;
  }
  .grablist-image {
    width: auto;
    height: 160px;
    margin-bottom: 10px;
    object-fit: cover; /* ทำให้รูปภาพเต็มพื้นที่สี่เหลี่ยมจตุรัส */
    /* border: #cdcdcd 1px solid; */
    border-radius: 10px;
    /* box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.3); */
}
.img-banner-grab {
  position: absolute; 
  bottom: 50px; left: 450px;
}
}

@keyframes shake {
  0% { transform: translateX(0); }
  20% { transform: translateX(-4px); }
  40% { transform: translateX(4px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
  100% { transform: translateX(0); }
}

.shake {
  animation: shake 0.6s ease-in-out;
  animation-iteration-count: infinite; /* หรือ 3 ถ้าอยากให้สั่นแค่ 3 ครั้ง */
}
.homepage-banner {
    background-image: 
    linear-gradient( #ffffff 40%, rgba(255, 255, 255, 0.1)), 
    url('/img/promotegrab/standard01.png'); /* เปลี่ยน path ตามจริง */ /* ใช้รูปโปร่งจาง หรือ gradient */
  background-size: cover;
  background-position: center;
  min-height: 50vh;
}

.store-icon {
  height: 40px;
}

</style>